/**
 * Farbpalette der Welt — dieselbe Familie wie die CSS-Tokens, damit
 * UI-Chrome und 2D-Welt wie ein Produkt wirken. Werte als Pixi-Hex-Zahlen.
 */
export const WORLD = {
  background: 0x1e2430,
  floorWood: 0xeadfce,
  floorWoodLine: 0xddcfba,
  floorCarpetBlue: 0xcfe8e5,
  floorCarpetGreen: 0xd6e8cf,
  floorCarpetWarm: 0xf6ddd3,
  floorStone: 0xe4e2dd,
  wall: 0x39414f,
  wallTop: 0x4a5363,
  plantPot: 0xb96f4d,
  plantLeaf: 0x3bb273,
  plantLeafDark: 0x2f8f5b,
  plantCactus: 0x4caf6e,
  desk: 0xc9a87c,
  deskTop: 0xd8bb92,
  deskEdge: 0xb8935f,
  monitor: 0x2b3240,
  monitorScreen: 0x3a4f6b,
  keyboard: 0xd7dbe1,
  chair: 0x7a8699,
  /** Lehne — dunkler als der Sitz, damit die Blickrichtung von oben lesbar ist. */
  chairBack: 0x5d687a,
  table: 0xc9a87c,
  sofa: 0x9b8cff,
  sofaCushion: 0xafa3ff,
  whiteboard: 0xffffff,
  whiteboardFrame: 0x39414f,
  stickyboard: 0xd9b98a,
  screenDark: 0x232a38,
  screenGlow: 0x2ec4b6,
  linkKiosk: 0x2ec4b6,
  youtubeRed: 0xff6b5e,
  shadow: 0x1e2430,
  floorConference: 0xcfd8ee,
  floorConferenceLine: 0xbcc8e6,
  windowPane: 0xa9cdf0,
  shelfWood: 0x9a6b4a,
  shelfBooks: 0xd8bb92,
  cabinetFront: 0xb08a5f,
  coffeeDark: 0x39414f,
  pictureFrame: 0x9a6b4a,
  pictureMat: 0xf4efe6,
  calendarPaper: 0xffffff,
  calendarRed: 0xff6b5e,
  porcelain: 0xeef2f5,
  porcelainShade: 0xcdd8de,
  serverBody: 0x2b3240,
  serverSlot: 0x39414f,
  crate: 0x6b8fb5,
  crateBottle: 0x3bb273,
  fridgeBody: 0xdfe6ea,
  // Spielautomat + Spieltisch
  arcadeBody: 0x39414f,
  arcadeCabinet: 0x2b3240,
  arcadeScreen: 0x2ec4b6,
  arcadeGlow: 0xff6b5e,
  boardFrame: 0x9a6b4a,
  boardLight: 0xf4efe6,
  boardDark: 0x7a8699,
  // Trennwand (WC-Stall)
  partition: 0xcdd8de,
} as const;

/** Avatar-Farben (Index = avatarColor aus dem Server, deterministisch). */
export const AVATAR_COLORS: readonly number[] = [
  0xff6b5e, // Koralle
  0x2ec4b6, // Teal
  0x9b8cff, // Lavendel
  0xf2b33d, // Honig
  0x3bb273, // Gruen
  0x5aa9e6, // Himmel
  0xe673b8, // Pink
  0x8a96a8, // Graublau
];

/** Zonenfarbe (CSS-Hex-String) in Pixi-Zahl umwandeln. */
export function cssHexToNumber(hex: string): number {
  return Number.parseInt(hex.replace('#', ''), 16);
}
